import { SubscriptionsClient } from "../proto/payments_grpc_web_pb"
import {
  ListSubscriptionRequest,
  GetSubscriptionRequest,
  Empty
} from "../proto/payments_pb"
import { frontendProxy } from "../../configs"
import { getSubscriptionRequestObject } from "./helpers"

export default class SubscriptionAPI {
  /**
   * Init the subscriptions api
   */
  constructor(jwt) {
    // init client
    if (jwt) {
      this.jwt = jwt
      this.baseMetadata = { authorization: `Bearer ${jwt}` }
      this.client = new SubscriptionsClient(frontendProxy)
    } else {
      throw new Error("jwt is required")
    }
  }

  /**
   * List of subscriptions
   */
  list() {
    const self = this
    const request = new ListSubscriptionRequest()

    // make request -> subscriptions list
    return new Promise((resolve, reject) => {
      self.client.list(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Get subscription
   *
   * @param {string} id - subscription's id
   * @returns {Promise} -
   */
  get(id) {
    const self = this
    const request = new GetSubscriptionRequest()
    request.setId(id)

    // make request -> subscription
    return new Promise((resolve, reject) => {
      self.client.get(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Create subscription
   *
   * @param {object} data - subscription's data
   * @returns {Promise} -
   */
  create(data) {
    const self = this
    const request = getSubscriptionRequestObject(data)

    // make request -> subscription
    return new Promise((resolve, reject) => {
      self.client.create(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Update the subcription plan.
   *
   * @param {string} priceType - month/year
   */
  changeSubscriptionPlan(priceType) {
    const self = this
    const request = getSubscriptionRequestObject({ priceType })

    // make request to update subscription plan
    return new Promise((resolve, reject) => {
      self.client.changeSubscriptionPlan(
        request,
        this.baseMetadata,
        (err, res) => {
          err ? reject(err) : resolve(res.toObject())
        }
      )
    })
  }

  /**
   * Cancel subscription
   */
  cancelSubscription() {
    const self = this
    const request = new Empty()

    // make request -> cancel subscription
    return new Promise((resolve, reject) => {
      self.client.cancelSubscription(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Get Subscription Info
   */
  getSubscriptionInfo() {
    const self = this
    const request = new Empty()

    // make request -> cancel subscription
    return new Promise((resolve, reject) => {
      self.client.getSubscriptionInfo(
        request,
        this.baseMetadata,
        (err, res) => {
          err ? reject(err) : resolve(res.toObject())
        }
      )
    })
  }

  /**
   * Load invoices for the organization
   */
  listInvoices() {
    const self = this
    const request = new Empty()

    // make request to list invoices
    return new Promise((resolve, reject) => {
      self.client.listInvoices(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }
}
